export const contactInfo = {
  phoneDisplay: "0501 577 10 91",
  phoneHref: "tel:+905015771091",
  whatsappHref: "https://wa.me/905015771091?text=Merhaba%2C%20Has%20K%C4%B1r%C4%B1khan%20Nakliyat%20i%C3%A7in%20fiyat%20teklifi%20almak%20istiyorum.",
  email: "info@haskirikhannakliyat.com",
  address: "Cumhuriyet Mah. 338 Sk. Kaynaklar İnşaat Sitesi Kaynak Apt No: 22 İç Kapı No: 2, Kırıkhan / Hatay",
  publicLocationLabel: "Kırıkhan / Hatay — konum için haritayı açın",
  hours: "Her gün 08:00 - 22:00",
  googleMapsUrl: "https://www.google.com/maps/search/?api=1&query=Co%C5%9Fkun%20Eczanesi%20338.%20Sokak%20Cumhuriyet%20Mahallesi%20K%C4%B1r%C4%B1khan%20Hatay",
  mapEmbedUrl: "https://maps.google.com/maps?q=Co%C5%9Fkun%20Eczanesi%20338.%20Sokak%20Cumhuriyet%20Mahallesi%20K%C4%B1r%C4%B1khan%20Hatay&output=embed",
  geo: {
    latitude: 36.4936,
    longitude: 36.3667,
  },
};

export const siteBaseUrl = "https://haskirikhannakliyat.com.tr";

export const media = {
  logo: "/has-kirikhan-logo-sade.jpg?v=3",
  hero: "https://static.prod-images.emergentagent.com/jobs/9bf45448-27bf-474d-892f-c1c4a9c4340a/images/73b947d6a45926486ec355e48ff8c77c06da58bf33c1f34c54277e75c599b713.png",
  home: "https://static.prod-images.emergentagent.com/jobs/9bf45448-27bf-474d-892f-c1c4a9c4340a/images/b99896c259657bc944869696b28967fc04631cb85595b0ddb0e5b59262c4ea87.png",
  office: "https://static.prod-images.emergentagent.com/jobs/9bf45448-27bf-474d-892f-c1c4a9c4340a/images/eff1bb8730a903623c297f2a6b3f1807f03ff33d1435360d9823def1451c646e.png",
  elevator: "https://static.prod-images.emergentagent.com/jobs/9bf45448-27bf-474d-892f-c1c4a9c4340a/images/566ea76693448bcabb8107a6b8723f749b9c5c26f6489079e2dde9c010ba52d8.png",
  intercity: "https://images.unsplash.com/photo-1473445730015-841f29a9490b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxkZWxpdmVyeSUyMHRydWNrJTIwbW92aW5nfGVufDB8fHx8MTc3ODc4OTI2MHww&ixlib=rb-4.1.0&q=85",
};

export const services = [
  {
    id: "home-moving",
    slug: "evden-eve-nakliyat",
    title: "Evden Eve Nakliyat",
    seoTitle: "Kırıkhan Evden Eve Nakliyat | Has Kırıkhan Nakliyat",
    seoDescription: "Kırıkhan ve Hatay çevresinde güvenilir evden eve nakliyat. Has Kırıkhan Nakliyat ile paketleme, taşıma ve yerleştirme desteği alın.",
    description: "Eşyalarınızı paketleme, taşıma ve yerleştirme adımlarıyla özenle teslim ediyoruz.",
    image: media.home,
  },
  {
    id: "office-moving",
    slug: "ofis-tasima",
    title: "Ofis Taşıma",
    seoTitle: "Kırıkhan Ofis Taşıma | Has Kırıkhan Nakliyat Hatay",
    seoDescription: "Hatay Kırıkhan'da planlı ofis taşıma hizmeti. Has Kırıkhan Nakliyat ile iş akışınızı aksatmadan güvenli taşının.",
    description: "İş akışınızı aksatmadan, planlı ve hızlı ofis taşımacılığı sağlıyoruz.",
    image: media.office,
  },
  {
    id: "intercity-moving",
    slug: "sehir-ici-sehirler-arasi-nakliyat",
    title: "Şehir İçi / Şehirler Arası",
    seoTitle: "Hatay Şehirler Arası Nakliyat | Has Kırıkhan Nakliyat",
    seoDescription: "Kırıkhan çıkışlı şehir içi ve şehirler arası nakliyat. Hatay ve Türkiye geneli rota planı, güvenli taşıma ve zamanında teslim.",
    description: "Hatay merkezli güvenilir rota planı, zamanında teslim ve düzenli bilgilendirme.",
    image: media.intercity,
  },
  {
    id: "elevator-moving",
    slug: "asansorlu-tasima",
    title: "Asansörlü Taşıma",
    seoTitle: "Kırıkhan Asansörlü Taşıma | Has Kırıkhan Nakliyat",
    seoDescription: "Kırıkhan ve Hatay'da asansörlü taşıma hizmeti. Yüksek katlarda güvenli, hızlı ve profesyonel nakliyat çözümleri.",
    description: "Yüksek katlarda güvenli, hızlı ve bina içi riski azaltan profesyonel çözüm.",
    image: media.elevator,
  },
];

export const homeSeo = {
  title: "Has Kırıkhan Nakliyat | Kırıkhan Evden Eve Nakliyat ve Şehirler Arası Taşımacılık",
  description: "Kırıkhan ve Hatay bölgesinde 20+ yıllık tecrübeli evden eve nakliyat. Sigortalı taşımacılık, asansörlü hizmet, şehirler arası nakliye. Ücretsiz keşif ve fiyat teklifi.",
  path: "/",
};

export const galleryImages = [
  {
    id: "gallery-elevator-building-wide",
    title: "Asansörlü taşıma operasyonu",
    caption: "Yüksek katlara güvenli ve kontrollü eşya taşıma.",
    src: "https://customer-assets.emergentagent.com/job_kiran-nakliyat/artifacts/rvu12bfm_WhatsApp%20Image%202026-05-19%20at%2021.47.01%20%282%29.jpeg",
  },
  {
    id: "gallery-elevator-building-close",
    title: "Apartman taşıma çalışması",
    caption: "Eşya asansörüyle bina içi riski azaltan profesyonel süreç.",
    src: "https://customer-assets.emergentagent.com/job_kiran-nakliyat/artifacts/dgug46x3_WhatsApp%20Image%202026-05-19%20at%2021.47.01%20%281%29.jpeg",
  },
  {
    id: "gallery-lift-sky",
    title: "Modern ekipman gücü",
    caption: "Asansörlü nakliyatta hızlı kurulum ve sağlam ekipman.",
    src: "https://customer-assets.emergentagent.com/job_kiran-nakliyat/artifacts/jp0fejjb_WhatsApp%20Image%202026-05-19%20at%2021.47.01.jpeg",
  },
  {
    id: "gallery-truck-loading",
    title: "Paketli eşya yükleme",
    caption: "Paketlenmiş eşyalar düzenli şekilde araca alınır.",
    src: "https://customer-assets.emergentagent.com/job_kiran-nakliyat/artifacts/pm04m81z_WhatsApp%20Image%202026-05-19%20at%2021.47.00%20%284%29.jpeg",
  },
  {
    id: "gallery-elevator-vertical",
    title: "Yüksek kat çözümü",
    caption: "Balkon ve cephe erişimiyle pratik taşıma avantajı.",
    src: "https://customer-assets.emergentagent.com/job_kiran-nakliyat/artifacts/ug9xopfd_WhatsApp%20Image%202026-05-19%20at%2021.47.00%20%283%29.jpeg",
  },
  {
    id: "gallery-new-wide-street-lift",
    title: "Cadde üzeri asansörlü taşıma",
    caption: "Yoğun cadde koşullarında güvenli kurulum ve kontrollü taşıma.",
    src: "https://customer-assets.emergentagent.com/job_kiran-nakliyat/artifacts/onj11vhk_WhatsApp%20Image%202026-05-20%20at%2019.48.36.jpeg",
  },
  {
    id: "gallery-new-facade-lift",
    title: "Cepheye güvenli erişim",
    caption: "Apartman cephesinde yüksek kata hızlı ve düzenli taşıma desteği.",
    src: "https://customer-assets.emergentagent.com/job_kiran-nakliyat/artifacts/1h2xu1eq_WhatsApp%20Image%202026-05-20%20at%2019.48.34%20%281%29.jpeg",
  },
  {
    id: "gallery-new-loaded-truck",
    title: "Yüklü araç operasyonu",
    caption: "Eşyaların araçtan asansöre planlı aktarımıyla pratik taşıma.",
    src: "https://customer-assets.emergentagent.com/job_kiran-nakliyat/artifacts/you7z97m_WhatsApp%20Image%202026-05-20%20at%2019.49.59.jpeg",
  },
  {
    id: "gallery-new-construction-height",
    title: "Yüksek kat şantiye taşıması",
    caption: "Zorlu cephelerde uzun erişimli asansörlü taşıma kabiliyeti.",
    src: "https://customer-assets.emergentagent.com/job_kiran-nakliyat/artifacts/d60x8v1u_WhatsApp%20Image%202026-05-20%20at%2019.49.50.jpeg",
  },
  {
    id: "gallery-new-crane-side",
    title: "Has Kırıkhan araç filosu",
    caption: "Güçlü ekipmanla asansörlü nakliyat ve kiralık asansör hizmeti.",
    src: "https://customer-assets.emergentagent.com/job_kiran-nakliyat/artifacts/xnylhrnj_WhatsApp%20Image%202026-05-20%20at%2019.49.48%20%281%29.jpeg",
  },
  {
    id: "gallery-new-renovation-lift",
    title: "Tadilat ve eşya taşıma desteği",
    caption: "Bina dışından güvenli erişimle hızlı yük indirme ve çıkarma.",
    src: "https://customer-assets.emergentagent.com/job_kiran-nakliyat/artifacts/xkv1q12g_WhatsApp%20Image%202026-05-20%20at%2019.49.48.jpeg",
  },
  {
    id: "gallery-new-street-lift-second",
    title: "Saha çalışması görünümü",
    caption: "Gerçek operasyonlardan güçlü asansörlü nakliyat kareleri.",
    src: "https://customer-assets.emergentagent.com/job_kiran-nakliyat/artifacts/z5kaelfx_WhatsApp%20Image%202026-05-20%20at%2019.48.36.jpeg",
  },
];